<template>
  <div id="fulled-root" class="text-center quest_topic">
    <div>
      <v-card style="text-align: center">
        <!-- <v-img :src="$store.state.server + '/admin/img/fullpsd.jpg'"></v-img> -->
        <!-- 修正破圖問題 -->  
        <img v-bind:src="$store.state.server +'/admin/img/fullpsd.jpg'" style="max-width: 100%" />
        <!-- local端測試 -->
        <!-- <img v-bind:src="$store.state.adminServer +'/img/fullpsd.jpg'" style="max-width:100%;"/> -->
        <p style="margin-bottom: 0">sorry...回覆已經額滿了~</p>
        <p>下次加緊腳步吧!</p>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
#fulled-root {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
p {
  margin-bottom: 0;
}
</style>
